import(/* webpackMode: "eager" */ "/vercel/path0/app/image-compressor/page.tsx");
